<template>
    <div>
        <div name="query-sort-block">
            <swb-query-sort-area ref="query_model_ctrl" :confKey="confKey" :configAuto="true" :queryOnLoad="true" :queryHandler="queryHandler"></swb-query-sort-area>
        </div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="维修工单" name="0"></el-tab-pane>
            <el-tab-pane label="保养工单" name="1"></el-tab-pane>
            <el-tab-pane label="检验工单" name="6"></el-tab-pane>
            <el-tab-pane label="安装工单" name="2"></el-tab-pane>
        </el-tabs>
        <div class="simple-row" name="btn-block">
            <div class="right">
                <span class="swb-btn swb-btn-small swb-btn-primary" @click="exportExcel">导出</span>
            </div>
        </div>
        <swb-result-table name="result_table" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :height="theTableHeight" :pageNoChangeHandler="pageNoChangeHandler" :rowDblClickHandler="rowDblClickHandler" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed"></swb-result-table>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, Routes, DomSizeWatcher } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'
    import { showGrpDownloadDlg } from '../ctrl/dialog'

    import servcDelivApi from '../../api/servcDeliv'

    import SwbOrgTree from '../orgStruct/OrgTree';
    Vue.regist(SwbOrgTree);
    //
    import SwbResultColConf from '../query/ResultColConf.vue';
    import SwbResultTable from '../query/ResultTable.vue';

    Vue.regist(SwbResultColConf);
    Vue.regist(SwbResultTable);

    import SwbServcWorkVoucherExportPdf from '../workVoucher/ServcWorkVoucherExportPdf'
    Vue.regist(SwbServcWorkVoucherExportPdf);

    import SwbServcWorkVoucherProductList from '../workVoucher/ServcWorkVoucherProductList';// 维修工单
    import SwbServcWorkVoucherMaintList from '../workVoucher/ServcWorkVoucherMaintList';// 保养工单
    import SwbServcWorkVoucherDetectionList from '../workVoucher/ServcWorkVoucherDetectionList';// 检验工单
    import SwbServcWorkVoucherInstallList from '../workVoucher/ServcWorkVoucherInstallList';// 安装工单
    import SwbServcWorkVoucherServcList from '../workVoucher/ServcWorkVoucherServcList';// 全部工单

    Vue.regist(SwbServcWorkVoucherProductList);
    Vue.regist(SwbServcWorkVoucherMaintList);
    Vue.regist(SwbServcWorkVoucherDetectionList);
    Vue.regist(SwbServcWorkVoucherInstallList);
    Vue.regist(SwbServcWorkVoucherServcList);

    export default {
        name: 'swb-shop-device-servc-rec-list-dlg',
        desc: '资产服务记录',
        props: {
            deviceSubNoId: {
                type: Number
            },
            toServcWork: {
                type: Function,
                default: null
            }
        },
        data: function () {
            return {
                confKey: "swb-shop-device-servc-rec-list-dlg",
                theTableHeight: 408,
                //
                needPager: true, //是否需要分页（默认：true）
                multiSelect: false, //是否多选（默认：false）
                multiPageSelect: false, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: false, //行号列是否固定（默认：false）
                btnColName: 'actions',//操作列名称（如果不设置就不显示操作列）
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 100,//操作列宽度（默认：100）
                btnColFixed: true, //操作列是否固定
                //
                pageSize: getDefaultPageSizes().first(),
                pageNumber: 1,
                totalCount: 0,
                lastPageNumber: null,
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
                //
                includeSubComs: false,
                initIncludeSubComs: false,
                comLevel: null,
                selectComId: null,
                workServcTypeMap: {},
                exportParams: {},
                activeName: '0'
            }
        },
        created: function () {
            //
            this.workServcTypeMap = getEnumMap('workServcType', 'value2text');
        },
        mounted() {
            this.initResultTable();
        },
        methods: {
            handleClick(){
                this.pageNumber = 1;
                this.getShopDeviceRecList();
            },
            rowDblClickHandler: function (row) {
                if(!this.multiSelect) {
                    console.log("----- 双击数据行 ----");
                    console.log(row);
                }
            },
            initResultTable() {
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[查询排序对象]到结果表格（结果表格可以实时利用最新的 列配置 和 排序信息，同时结果表格列宽也会反向同步到其中的[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'bizNo': function (row, colName, colValue, rowIndex, colConf) {
                        return '<span><a class="swb-btn-link" >' + row.bizNo + '</a></span>';
                    },
                    'servcTypeName': function (row, colName, colValue, rowIndex, colConf) {
                        return self.workServcTypeMap[row.servcType];
                    },
                    'actions': function (row, colName, colValue, rowIndex) {
                        return '<span><a class="swb-btn-link">凭单下载</a></span>';
                    }
                }, {
                    'bizNo': function (row, colName, colValue, rowIndex, btnName) {
                        self.gotoServcWork(row);
                    },
                    'actions': function (row, colName, colValue, rowIndex, btnName) {
                        self.doExport(row.bizId, row.bizNo, row.servcType);
                    }
                });
            },
            renderTable(rows, pagination) {
                //
                let resultTable = this.$refs.result_table;
                //清除数据（如果已经渲染的数据与新的列不是一回事儿）
                //resultTable.clear();
                //同步使用新的自定义列信息
                //resultTable.initMeta(confColList);
                //设置新数据
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };

                resultTable.render(tableData);
            },
            checkComCatChange: function (eventData) {
                let self = this;
                self.comLevel = eventData.level;
                self.selectComId = eventData.id;
                self.includeSubComs = eventData.includeSubComs;
                self.getShopDeviceRecList();
            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log("分页 => 第【" + pageNumber + "】页，大小：" + pageSize);
                //
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                this.lastPageNumber = null;
                //
                this.getShopDeviceRecList();
            },
            getShopDeviceRecList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems.includeSubComs = true;
                filterItems.deviceSubNoId = this.deviceSubNoId;
                filterItems.servcType = this.activeName;
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                self.exportParams = filterItems;
                //
                let msgBoxDlg = MsgBox.loading();
                servcDelivApi.getDeviceServcRecDtoList(postData, function (result) {
                    msgBoxDlg.close();
                    if(result.type == 'info') {
                        let shopDeviceRecList = result.data.rows;
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.renderTable(shopDeviceRecList, pagination);
                    } else {
                        self.$message.warning(result.message);
                    }
                });
            },
            queryEventHanlder: function (postData) {
            },
            queryHandler: function (queryModel) {
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.lastPageNumber = null;
                this.getShopDeviceRecList();
            },
            doExport: function (id, no, servcType) {
                let self = this;
                let theDlg = Vue.$showDialog({
                    title: '凭单-下载',
                    width: 1100,
                    height: 750,
                    showCloseBtn: true,
                    okVisible: false,
                    template: '<div class = "">' +
                    '<swb-servc-work-voucher-export :voucherId="voucherId" :no="no" :servcType="servcType" ref="swb_servc_work_voucher_export"></swb-servc-work-voucher-export>' +
                    '</div>',
                    data: {
                        voucherId: id,
                        no: no,
                        servcType: servcType,
                    }
                });
            },
            gotoServcWork(row){
                let no = row.bizNo;
                let servcType = row.servcType;
                let path = null;
                if(servcType == 0) {
                    path = SwbServcWorkVoucherProductList.path;
                } else if(servcType == 1) {
                    path = SwbServcWorkVoucherMaintList.path;
                } else if(servcType == 2) {
                    path = SwbServcWorkVoucherInstallList.path;
                } else if(servcType == 6) {
                    path = SwbServcWorkVoucherDetectionList.path;
                } else {
                    path = SwbServcWorkVoucherServcList.path;
                }
                this.toServcWork({
                    query: {
                        no: no
                    },
                    path: path
                });
            },
            exportExcel(){
                let self = this;
                let pageSize = 2000;
                let totalCount = this.totalCount;
                let pages = Math.ceil(totalCount / pageSize);
                if(pages > 10) {
                    showPageRangeSelDlg("选择导出文件序号", pages, 10, this.lastPageNumber, function (ok, range) {
                        if(ok) {
                            if(range.to == pages) {
                                self.lastPageNumber = 0;
                            } else {
                                self.lastPageNumber = range.to;
                            }
                            //
                            self.exportPrintData(pageSize, range.from, range.to);
                        }
                    }, {pageSize: pageSize})
                } else {
                    self.exportPrintData(pageSize);
                }
            },
            exportPrintData(pageSize, fromPages, toPages){
                let title = '服务记录';
                let activeName = this.activeName;
                if(activeName == 0){
                    title = title + "_维修工单";
                } else if(activeName == 1){
                    title = title + "_保养工单";
                } else if(activeName == 6){
                    title = title + "_检验工单";
                } else if(activeName == 2){
                    title = title + "_安装工单";
                }
                let totalCount = this.totalCount;
                let pages = Math.ceil(totalCount / pageSize);
                //
                fromPages = fromPages == null ? 1 : fromPages;
                toPages = toPages == null ? pages : toPages;
                let tableData = this.getTableData(pages, pageSize);
                //
                let url = getAppUrl("/file/export/as/excel");
                let downloadUrls = [];
                for(let i = fromPages; i <= toPages; i++) {
                    let tmpFile = {};
                    tmpFile.url = url;
                    tmpFile.post = true;
                    tmpFile.fileName = title + (pages == 1 ? '' : ("_" + (i)));
                    tmpFile.seqNo = i;
                    //
                    let data = Utils.merge({}, tableData);
                    data.pageNumber = i;
                    data.fileName = tmpFile.fileName;
                    tmpFile.data = data;
                    downloadUrls.push(tmpFile);
                }
                title = title + '-下载| 每个文件' + pageSize + '条数据';
                showGrpDownloadDlg(title + '-下载', downloadUrls);
            },
            getTableData(pages, pageSize){
                let resultTable = this.$refs.result_table;
                let tableData = resultTable.getTableData(true);
                delete tableData.rows;//减少数据传输量
                //
                let rowsSrc = {};
                rowsSrc.data = this.getPostData();
                rowsSrc.url = "/servcDeliv/device/servc/rec/list";
                tableData.rowsSrc = rowsSrc;
                //
                tableData.pageSize = pageSize;
                tableData.pageCount = this.totalCount;
                tableData.pages = pages;
                return tableData;
            },
            getPostData(){
                let queryModel = this.queryModel;
                let filterItems = Utils.merge({}, this.exportParams);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems.exportFlag = true;
                let postData = {};
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                return postData;
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/retailer/ShopDeviceServcRecListDlg.vue